<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            Générer mails comptes annuels - Exercice {{ params.exercice }}
        </div>

        <div slot="body">
            <div
                v-if="items && items.length > 0"
                class="h6 mt-2"
            >
                Un mail sera envoyé aux clients ci-dessous:
            </div>

            <base-table
                :items="items"
                :meta="meta"
                :params="exParams"
                :loading="loading"
                :head="{cegid: 'CEGID', client: 'Client', email: 'Email', is_send_mail_active: 'Envoyer au client'}"
                name="mail"
                class="mt-3"
                @orderBy="orderBy"
                @change-page="goToPage"
            >
                <div slot="before" />

                <tr
                    v-for="ficheResultat of items"
                    :key="ficheResultat.id"
                >
                    <td>{{ ficheResultat.dossier.cegid }}</td>

                    <td>
                        <template v-if="ficheResultat.dossier.client.is_indivision">
                            {{ ficheResultat.dossier.client.type_indivision }} {{ ficheResultat.dossier.client.libelle_indivision }}
                        </template>

                        <template v-else>
                            {{ ficheResultat.dossier.client.nom }} {{ ficheResultat.dossier.client.prenom }}
                        </template>
                    </td>

                    <td>{{ ficheResultat.dossier.client.email }}</td>

                    <td>{{ ficheResultat.dossier.client.is_send_mail_active | yesNo }}</td>

                    <td class="text-center">
                        <router-link
                            :to="{name: 'dossier', params: {id: ficheResultat.dossier.id}}"
                            class="btn btn-primary btn-sm"
                            title="Voir"
                        >
                            <i class="fa fa-glasses" />
                        </router-link>
                    </td>
                </tr>

                <div slot="no-results">
                    <div class="text-center h3 mt-5 pt-5">
                        Aucun mail à envoyer...
                    </div>
                </div>
            </base-table>
        </div>

        <div
            v-if="items && items.length > 0"
            slot="footer"
        >
            <button
                v-btn-loading="sendingMails"
                class="btn btn-success"
                @click="sendMails"
            >
                Envoyer
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseTable from "../templates/BaseTable"
    import TableNavigate from "../../mixins/TableNavigate"

    export default {
        name: "GenererMailsComptesAnnuels",
        components: {BaseTable, BaseModal},

        mixins: [TableNavigate],

        url: '/api/fiche-resultats',

        props: {
            additionalParams: {type: Object, default: () => {return {}}}
        },

        data: function () {
            return {
                params: {
                    // Pour l'année fiscale (en juin il faut que ça bascule à l'année suivante)
                    exercice: moment().subtract(5, 'months').year(),
                    ...this.additionalParams,
                    resultat_statut: [this.$store.state.resultatStatuts.statutSupervise],
                },
                sendingMails: false,
            }
        },

        methods: {
            /**
             * Génère et envoie les mails de relance aux clients
             */
            sendMails: function () {
                this.sendingMails = true

                axios.post('/api/mails/send-mails-comptes-annuels', this.params).then(() => {
                    this.sendingMails = false
                    this.$notify('success', "Les mails de comptes annuels ont bien été générés et seront envoyés aux clients d'ici quelques minutes.")
                    this.$emit('close')
                }).catch(() => {
                    this.sendingMails = false
                    this.$notify('danger', "Une erreur est survenue lors de la génération des mails de comptes annuels .")
                })
            }
        }
    }
</script>
